import { isEmpty } from "../lodash/isEmpty";
import { POSTAL_CODE_REGEX } from "./helper";

export function checkPostalCode(postalCode: string) {
  if (isEmpty(postalCode)) {
    return false;
  }

  const regex = new RegExp(POSTAL_CODE_REGEX);

  return regex.test(postalCode.toUpperCase().replace(/\W+/g, ""));
}
